// extracted by mini-css-extract-plugin
export default {"Container":"TaskContainer_Container__ODMlq","Container__Heading":"TaskContainer_Container__Heading__azlHf"};